import React from 'react';
import { Stack } from '@mui/material';
import { Autorenew, Download, History, NoteAdd, OpenInNew, Visibility } from '@mui/icons-material';
import DateColumn from '../../../../custom-components/Table/column-definitions/DateColumn';
import ActionButton, { ActionSlot } from '../../FunctionalApps/inspect/processed-fluids-route-session/DocumentActionButton';
import { deliveryStatusLabel, reportTypeLabel } from './constants';

const text = (value) => (value == null || value === '' ? '-' : value);

export const ACTIONS_FIELD = 'actions';

const getDeliveryDocumentColumns = ({ localization, onInspect, onView, onDownload, onHistory, onGenerate, busy }) => [
    DateColumn({ field: 'created_at', headerName: 'Session Date', format: 'MM/DD/YYYY', width: 130 }),
    { field: 'route', headerName: 'Route', minWidth: 140, flex: 1, valueGetter: ({ row }) => text(row.route_id?.name ?? row.route_number) },
    { field: 'BOL', headerName: 'LT Number', minWidth: 130, flex: 1, valueGetter: ({ value }) => text(value) },
    { field: 'manifest_number', headerName: 'Manifest', minWidth: 120, flex: 1, valueGetter: ({ value }) => text(value) },
    { field: 'hauler', headerName: localization.general.hauling_singular, minWidth: 150, flex: 1, valueGetter: ({ row }) => text(row.hauling_id?.name) },
    { field: 'processor', headerName: localization.general.processor_singular, minWidth: 150, flex: 1, valueGetter: ({ row }) => text(row.processor?.name) },
    { field: 'delivery_status', headerName: 'Delivery Status', minWidth: 170, valueGetter: ({ value }) => deliveryStatusLabel(value) },
    { field: 'report_type', headerName: 'Type', width: 120, valueGetter: ({ row }) => reportTypeLabel(row.document) },
    { field: 'version', headerName: 'Version', width: 100, valueGetter: ({ row }) => (row.document ? `v${row.document.version}` : '-') },
    DateColumn({ field: 'generated_at', headerName: 'Generated', format: 'MM/DD/YYYY HH:mm', width: 160, valueGetter: ({ row }) => row.document?.generated_at }),
    { field: 'generated_by', headerName: 'Generated By', minWidth: 150, flex: 1, valueGetter: ({ row }) => text(row.document?.generated_by?.name) },
    {
        field: ACTIONS_FIELD,
        headerName: 'Actions',
        width: 226,
        align: 'right',
        headerAlign: 'right',
        sortable: false,
        filterable: false,
        disableColumnMenu: true,
        renderCell: ({ row }) => {
            const hasFile = !!row.document;
            return (
                <Stack direction="row" spacing={0.5} justifyContent="flex-end">
                    <ActionSlot>
                        <ActionButton label="Inspect Route Session" Icon={OpenInNew} disabled={busy} onClick={() => onInspect(row)} />
                    </ActionSlot>
                    <ActionSlot>{hasFile && <ActionButton label="View" Icon={Visibility} disabled={busy} onClick={() => onView(row)} />}</ActionSlot>
                    <ActionSlot>{hasFile && <ActionButton label="Download" Icon={Download} disabled={busy} onClick={() => onDownload(row)} />}</ActionSlot>
                    <ActionSlot>{hasFile && <ActionButton label="History" Icon={History} disabled={busy} onClick={() => onHistory(row)} />}</ActionSlot>
                    <ActionSlot>
                        <ActionButton label={hasFile ? 'Regenerate' : 'Generate'} Icon={hasFile ? Autorenew : NoteAdd} disabled={busy} onClick={() => onGenerate(row)} />
                    </ActionSlot>
                </Stack>
            );
        },
    },
];

export default getDeliveryDocumentColumns;
